import { render } from "./BatchProcess.vue?vue&type=template&id=8d8a30cc&scoped=true&ts=true"
import script from "./BatchProcess.vue?vue&type=script&lang=ts"
export * from "./BatchProcess.vue?vue&type=script&lang=ts"

import "./BatchProcess.vue?vue&type=style&index=0&id=8d8a30cc&lang=less"
import "./BatchProcess.vue?vue&type=style&index=1&id=8d8a30cc&scoped=true&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d8a30cc"]])

export default __exports__